import styled from "styled-components";

const AboutWrapper = styled.div`
  .about-us-page {
    width: 100%;
  }

  p.react-reveal.subhead {
    color: #efae4c;
    margin-bottom: 0;
  }
  img.areaImg {
    border-radius: 10px;
  }
  .myContainer {
    width: 100%;
  }
  /* ── Premium Stats + Features Section ── */
  .about-stats-section {
    padding: 60px 0 70px;
  }

  .about-stats-card {
    background-color: #1a1a1a;
    background-size: cover;
    background-position: center right;
    background-repeat: no-repeat;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0,0,0,0.35);
    position: relative;
  }

  .about-stats-card-overlay {
    display: flex;
    align-items: stretch;
    min-height: 400px;
  }

  .about-stats-content {
    flex: 0 0 65%;
    background: rgba(15, 15, 15, 0.93);
    display: flex;
    flex-direction: column;
  }

  .about-stats-image-side {
    flex: 0 0 35%;
    background-size: cover;
    background-position: right;
    background-repeat: no-repeat;
    position: relative;
  }

  .about-stats-image-side::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to right, rgba(15,15,15,0.35) 0%, rgba(0,0,0,0.05) 100%);
  }

  /* Stats Row */
  .stats-row {
    display: flex;
    align-items: stretch;
    border-bottom: 1px solid rgba(255,255,255,0.08);
    flex: 1;
  }

  .stat-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 30px;
    text-align: center;
    gap: 12px;
    transition: background 0.3s ease;
  }

  .stat-item:hover {
    background: rgba(225, 139, 42, 0.06);
  }

  .stat-number {
    font-size: 52px;
    font-weight: 800;
    color: #efae4c;
    font-family: 'Mulish', sans-serif;
    line-height: 1;
    letter-spacing: -1px;
  }

  .stat-label {
    font-size: 15px;
    font-weight: 500;
    color: #bbbbbb;
    text-transform: uppercase;
    letter-spacing: 1.5px;
  }

  .stat-divider {
    width: 1px;
    background: rgba(255,255,255,0.12);
    align-self: stretch;
    margin: 30px 0;
  }

  /* Features Row */
  .features-row {
    display: flex;
    align-items: stretch;
  }

  .feature-tile {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 52px 24px;
    text-align: center;
    gap: 18px;
    transition: filter 0.3s ease, transform 0.3s ease;
    cursor: default;
  }

  .feature-tile:hover {
    filter: brightness(1.1);
  }

  .feature-dark {
    background: #111111;
  }

  .feature-gold {
    background: #e18b2a;
  }

  .feature-rose {
    background: #c8aeab;
  }


  .feature-icon-wrap {
    width: 68px;
    height: 68px;
    border-radius: 50%;
    background: rgba(255,255,255,0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.3s ease;
  }

  .feature-tile:hover .feature-icon-wrap {
    background: rgba(255,255,255,0.2);
  }

  .feature-icon {
    width: 36px;
    height: 36px;
    object-fit: contain;
    filter: brightness(0) invert(1);
  }

  .feature-title {
    font-size: 17px !important;
    font-weight: 600 !important;
    color: #ffffff !important;
    margin: 0 !important;
    text-align: center;
    line-height: 1.4;
  }

  .feature-rose .feature-title {
    color: #ffffff !important;
  }

  .about-us-page .section-container {
    width: 100%;
    max-width: 1280px;
    z-index: 1;
    margin: auto;
    padding: 20px;
  }

  .about-us-page section {
    display: inline-flex;
    width: 100%;
  }

  .about-us-page .title-bar {
    position: relative;
    background-image: url(/about.png);
    text-align: center;
    min-height: 380px;
    height: auto;
    padding: 85px 24px 75px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    width: 100%;
    overflow: hidden;
  }
  .about-us-page .title-bar-overlay {
    position: absolute;
    inset: 0;
    top: 0px;
    left: 0px;
    background: linear-gradient(
      180deg,
      rgba(20, 16, 13, 0.82) 0%,
      rgba(20, 16, 13, 0.94) 100%
    );
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  .about-us-page .section-container {
    position: relative;
    z-index: 1;
    max-width: 1240px;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    box-sizing: border-box;
    text-align: center;
  }

  .about-us-page .title-bar-heading {
    font-family: "Playfair Display", Georgia, serif !important;
    font-size: 42px;
    font-weight: 700;
    line-height: 1.2;
    color: #ffffff !important;
    margin: 0 0 12px;
    text-shadow: 0 3px 14px rgba(0, 0, 0, 0.55);
  }
  .about-us-page .title-bar-breadcrumb {
    color: #ffffff !important;
    margin: 0;
    font-size: 15px;
    line-height: 24px;
    font-weight: 500;
    letter-spacing: 0.5px;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
  }

  .about-us-page .title-bar-separator {
    position: relative;
    bottom: 60px;
  }

  .about-us-page .title-bar-separator img.separator-image {
    width: 100%;
  }

  // .about-us-page .content-grid {
  //   display: grid;
  //   grid-template-columns: repeat(2, 1fr);
  //   gap: 30px;
  // }

  // .about-us-page .full-width {
  //   width: 100%;
  // }
  // .about-us-page .colored-sub-title {
  //   font-size: 20px;
  //   line-height: 24px;
  //   color: #a8600e;
  //   font-weight: 400;
  //   margin: 0;
  //   margin-bottom: 10px;
  // }
  // .about-us-page .title {
  //   font-family: Mulish;
  //   font-size: 28px;
  //   font-weight: 600;
  //   line-height: 50px;
  //   letter-spacing: 0em;
  //   text-align: left;
  //   margin: 0;
  // }

  // .about-section-two {
  //   padding: 60px 0;
  // }
  // .about-section-two .info-list-bg {
  //   background: #232122;
  // }
  // .about-section-two .info-list {
  //   background-image: url(/images/info-list-bg.png);
  //   background-repeat: no-repeat;
  //   background-size: cover;
  //   background-position: center;
  // }
  // .about-section-two .info-list {
  //   display: grid;
  //   grid-template-columns: repeat(3, 1fr);
  //   gap: 0;
  //   align-items: center;
  //   justify-items: center;
  //   justify-content: center;
  //   align-content: center;
  //   padding-right: 25%;
  // }
  // .about-section-two .info-list .list-item {
  //   width: 100%;
  //   text-align: center;
  //   height: 325px;
  //   display: flex;
  //   flex-direction: column;
  //   align-content: center;
  //   align-items: center;
  //   justify-content: center;
  // }
  // .about-section-two .info-list .list-item .item-title {
  //   font-size: 66px;
  //   line-height: 77px;
  //   color: #fff;
  //   font-weight: 600;
  //   margin: 0;
  // }
  // .about-section-two .info-list .list-item .item-subtitle {
  //   font-size: 24px;
  //   line-height: 28px;
  //   font-weight: 400;
  //   color: #fff;
  //   margin: 0;
  // }
  // .about-section-two .info-list .list-item .item-image {
  //   width: 75px;
  //   margin-bottom: 10px;
  // }
  // .about-section-two .info-list .list-item-2 {
  //   border-left: 1px solid #474747;
  //   border-right: 1px solid #474747;
  // }
  // .about-section-two .info-list .list-item-4 {
  //   background: #0b0b0b;
  // }
  // .about-section-two .info-list .list-item-5 {
  //   background: #e18b2a;
  // }
  // .about-section-two .info-list .list-item-6 {
  //   background: #c8aeab;
  // }

  // .about-section-three {
  //   padding-bottom: 60px;
  // }
  // .about-section-three .area-title {
  //   font-size: 28px;
  //   line-height: 32px;
  //   font-weight: 700;
  //   margin: 0;
  // }
  // .about-section-three .area-text p {
  //   font-size: 15px;
  //   font-weight: 400;
  //   line-height: 26px;
  //   letter-spacing: 0em;
  //   text-align: left;
  //   color: #6b6b6b;
  // }
  // .about-section-three .area-2 {
  //   margin-top: 50px;
  // }
  // .about-section-three .section-gray-bg {
  //   background: linear-gradient(
  //     to right,
  //     white 25%,
  //     #f6f6f6 25%,
  //     #f6f6f6 100%,
  //     white 75%
  //   );
  //   padding: 60px 0;
  // }
  // .about-section-three .content-section {
  //   padding-right: 30px;
  // }

  @media only screen and (max-device-width: 1024px) {
    .about-us-page .title-bar-separator {
      position: relative;
      bottom: 48px !important;
    }
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    .about-section-two {
      padding: 20px 0 !important;
    }
    .about-section-two .info-list .list-item .item-subtitle {
      font-size: 20px !important;
      line-height: 24px !important;
    }
    .about-section-two .info-list .list-item .item-title {
      font-size: 50px !important;
      line-height: 60px !important;
    }
    .about-section-two .info-list .list-item {
      height: 250px !important;
    }
  }

  @media only screen and (max-width: 768px) {
    .about-stats-card-overlay {
      flex-direction: column;
    }

    .about-stats-content {
      flex: 1 1 auto;
    }

    .about-stats-image-side {
      flex: 0 0 220px;
      min-height: 220px;
    }

    .stats-row {
      flex-direction: column;
    }

    .stat-divider {
      width: 80%;
      height: 1px;
      margin: 0 auto;
    }

    .features-row {
      flex-direction: column;
    }

    .feature-tile {
      padding: 36px 20px;
    }

    .stat-item {
      padding: 40px 20px;
    }

    .stat-number {
      font-size: 40px;
    }

    img.full-width.areaImg {
      margin-bottom: 30px;
    }

    .about-us-page .title-bar {
      min-height: 240px;
      padding: 55px 16px 45px;
    }

    .about-us-page .title-bar-heading {
      font-size: 28px !important;
      line-height: 1.3 !important;
      margin-bottom: 8px;
    }

    .about-us-page .title-bar-breadcrumb {
      font-size: 13.5px !important;
    }

    .about-us-page .content-grid {
      grid-template-columns: repeat(1, 1fr) !important;
      gap: 30px;
    }
    .section-gray-bg {
      background: none !important;
      padding: 0 !important;
    }
  }

  @media only screen and (min-width: 769px) and (max-width: 1024px) {
    .stat-number {
      font-size: 38px;
    }

    .stat-item {
      padding: 48px 16px;
    }

    .feature-tile {
      padding: 40px 16px;
    }

    .about-stats-image-side {
      flex: 0 0 28%;
    }
  }
`;

export default AboutWrapper;
